import * as Sentry from '@sentry/react';
import React, { ReactNode } from 'react';

type Props = {
  parent?: string;
  children: ReactNode;
};

interface Error {
  stack?: string;
}

export default class CategoryBlockErrorBoundary extends React.Component<
  Props,
  { hasError: boolean }
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    // Check if we're on the server
    if (typeof window === 'undefined') {
      console.error(`[SSR Error][${this.props.parent}]:`, error);
      return;
    }

    Sentry.captureMessage(
      `[Category block ${this.props.parent}] Error: ${error.stack || error}`,
      'error',
    );
  }

  render() {
    if (this.state.hasError) {
      // Return null or a fallback UI for SSR
      return null;
    }

    return this.props.children;
  }
}
